const ProductShopSelector = require("../../../src/includes/shops/ProductShopSelector").default;
const React = require("react");
const { usePrintful } = require("../context/PrintfulContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, Button, ResourceState, ProductCard } = require("./ui");
const h = React.createElement;

const ProductCollectionPage = ({ title, description, supplierId, imported = false }) => {
  const { api, t } = usePrintful();
  const [shopIds, setShopIds] = React.useState(undefined);
  const [filters, setFilters] = React.useState({
    keyword: "", category: "", minPrice: "", maxPrice: "", status: "",
    shippingCountry: "", deliveryMinDays: "", deliveryMaxDays: "", supplierRating: "",
  });
  const [query, setQuery] = React.useState({});
  const [busy, setBusy] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [mutationError, setMutationError] = React.useState("");
  const resource = useResource(() => imported
    ? api.getImportedProducts({ ...query, page: 1, limit: 40 })
    : supplierId
      ? api.getSupplierProducts(supplierId, { ...query, page: 1, limit: 40 })
      : api.getProducts({ ...query, page: 1, limit: 40 }), [api, imported, supplierId, JSON.stringify(query)]);
  const change = (key) => (event) => setFilters((old) => ({ ...old, [key]: event.target.value }));
  const resetFilters = () => {
    setFilters((old) => Object.fromEntries(Object.keys(old).map((key) => [key, ""])));
    setQuery({});
  };
  const mutate = async (product, action, success) => {
    setBusy(product._id); setMessage(""); setMutationError("");
    try { await action(); setMessage(success); await resource.reload(); }
    catch (error) { setMutationError(error.message); }
    finally { setBusy(""); }
  };
  const products = resource.data?.products || [];
  return h(React.Fragment, null,
    h(PageHeader, { title, description }),
    !imported && h(ProductShopSelector, { value: shopIds, onChange: setShopIds }),
    h("form", { className: "pfds-toolbar", onSubmit: (event) => { event.preventDefault(); setQuery(filters); } },
      h("input", { className: "pfds-input", value: filters.keyword, onChange: change("keyword"), placeholder: t("h_pf_search", "Search product or SKU"), "aria-label": t("h_pf_search", "Search product or SKU") }),
      h("input", { className: "pfds-input", value: filters.category, onChange: change("category"), placeholder: t("h_pf_category", "Category") }),
      h("input", { className: "pfds-input", type: "number", min: "0", value: filters.minPrice, onChange: change("minPrice"), placeholder: t("h_pf_min_price", "Min price") }),
      h("input", { className: "pfds-input", type: "number", min: "0", value: filters.maxPrice, onChange: change("maxPrice"), placeholder: t("h_pf_max_price", "Max price") }),
      h("input", { className: "pfds-input", maxLength: 3, value: filters.shippingCountry, onChange: change("shippingCountry"), placeholder: t("h_pf_shipping_country", "Shipping country") }),
      h("input", { className: "pfds-input", type: "number", min: "0", value: filters.deliveryMinDays, onChange: change("deliveryMinDays"), placeholder: t("h_pf_min_delivery", "Min delivery days") }),
      h("input", { className: "pfds-input", type: "number", min: "0", value: filters.deliveryMaxDays, onChange: change("deliveryMaxDays"), placeholder: t("h_pf_max_delivery", "Max delivery days") }),
      h("input", { className: "pfds-input", type: "number", min: "0", max: "5", step: "0.1", value: filters.supplierRating, onChange: change("supplierRating"), placeholder: t("h_pf_supplier_rating", "Supplier rating") }),
      h("select", { className: "pfds-input", value: filters.status, onChange: change("status") },
        h("option", { value: "" }, t("h_pf_all_statuses", "All availability")),
        h("option", { value: "active" }, t("h_pf_active", "Active")),
        h("option", { value: "unavailable" }, t("h_pf_unavailable", "Unavailable")),
        h("option", { value: "imported" }, t("h_pf_imported", "Imported"))
      ),
      h(Button, { type: "submit" }, t("h_pf_filter", "Filter")),
      h(Button, { variant: "secondary", disabled: !Object.values(filters).some(Boolean) && !Object.values(query).some(Boolean), onClick: resetFilters }, t("h_pf_reset", "Reset")),
      !supplierId && !imported ? h(Button, { variant: "secondary", disabled: busy === "all", onClick: async () => { setBusy("all"); setMutationError(""); try { await api.syncAll(); await resource.reload(); } catch (error) { setMutationError(error.message); } finally { setBusy(""); } } }, busy === "all" ? t("h_pf_syncing", "Syncing…") : t("h_pf_sync_catalog", "Sync catalog")) : null
    ),
    message ? h("div", { className: "pfds-success" }, message) : null,
    mutationError ? h("div", { className: "pfds-alert", role: "alert" }, mutationError) : null,
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !products.length, reload: resource.reload, t },
      h("div", { className: "pfds-grid products" }, ...products.map((product) => h(ProductCard, {
        key: product._id,
        product,
        t,
        busy: busy === product._id,
        onImport: imported || product.elakayProductId ? null : () => {
          if (!window.confirm(t("h_pf_confirm_import", "Import this Printful product into your Elakay shop?"))) return;
          mutate(product, () => api.importProduct({ boutiqueId: shopIds, dropshippingProductId: product._id, selectedVariants: [], autoSync: true }), t("h_pf_import_success", "Product imported into Elakay."));
        },
        onSync: imported || product.elakayProductId ? () => mutate(product, () => api.syncProduct(product._id), t("h_pf_sync_success", "Product synchronized.")) : null,
      })))
    )
  );
};
module.exports = { ProductCollectionPage };
